module.exports = __webpack_public_path__ + "Tinebase/js/ace-c_cpp-FAT.js";